import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Panel } from "@/components/portal/widgets";
import fleetApi from "@/lib/fleetApi";

function Bar({ label, used, limit }) {
  const unlimited = limit == null;
  const pct = unlimited ? 0 : Math.min(100, Math.round((used / limit) * 100));
  const over = !unlimited && used >= limit;
  const near = !unlimited && pct >= 80 && !over;
  const color = over ? "bg-red-500" : near ? "bg-amber-400" : "bg-blue-500";
  return (
    <div data-testid={`usage-${label.toLowerCase()}`}>
      <div className="flex items-center justify-between text-sm">
        <span className="font-semibold text-slate-200">{label}</span>
        <span className="font-mono-data text-slate-400">{used}{unlimited ? "" : ` / ${limit}`}{unlimited ? " · Unlimited" : ""}</span>
      </div>
      <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-slate-800">
        <div className={`h-full rounded-full transition-all ${color}`} style={{ width: `${unlimited ? 6 : Math.max(pct, 3)}%` }} />
      </div>
    </div>
  );
}

export default function UsageMeter({ driversUsed, vehiclesUsed }) {
  const { entitlements } = useAuth();
  const navigate = useNavigate();
  const [fleetCount, setFleetCount] = useState(null);
  useEffect(() => {
    fleetApi.get("/vehicles").then((r) => setFleetCount((r.data || []).length)).catch(() => {});
  }, []);
  const limits = entitlements?.limits;
  if (!limits) return null;

  return (
    <Panel className="mt-6" title={`Plan usage — ${entitlements.plan_name || "Current plan"}`} testid="panel-usage"
      action={<button onClick={() => navigate("/portal/billing")} data-testid="usage-manage-btn" className="text-xs font-semibold text-blue-400 hover:text-blue-300">Manage plan</button>}>
      <div className="grid gap-5 p-5 sm:grid-cols-2">
        <Bar label="Drivers" used={driversUsed} limit={limits.drivers} />
        <Bar label="Vehicles" used={fleetCount ?? vehiclesUsed} limit={limits.vehicles} />
      </div>
    </Panel>
  );
}
